<template>
  <v-card>
    <v-card-title>
      <span class="headline">Cancel Booking</span>
    </v-card-title>
    <v-flex pa-4>
      <v-row>
        <v-flex
          shrink
        >
          <v-radio-group v-model="cancellationReason" row>
            <v-radio
              label="I no longer need this trip"
              :value="'I no longer need this trip'"
            />
            <v-radio
              label="My driver asked me to cancel"
              :value="'My driver asked me to cancel'"
            />
            <v-radio
              label="Driver was too far away"
              :value="'Driver was too far away'"
            />
            <v-radio
              label="Driver was too early"
              :value="'Driver was too early'"
            />
            <v-radio
              label="No Driver available"
              :value="'no driver available'"
            />
            <v-radio
              label="Other"
              :value="'other'"
            />
          </v-radio-group>
          <div>
            <v-col md="6">
              <v-textarea
                v-if="cancellationReason"
                class="small-text-field"
                label="Type cancellation reason"
                placeholder=" "
                :height="28"
                flat
                filled
                outlined
                dense
                v-model="otherCancellationReason"
              />

            </v-col>
          </div>
        </v-flex>
        <v-flex
          v-if="booking.card_payment_type != 'prepaid' && booking.payment_type == 'card'"
          shrink
        >
          <p>Cancellation Fee</p>
          <v-radio-group v-model="cancellationFee">
            <v-radio
              :label="'Use System Policy'"
              :value="0"
            />
            <v-radio
              label="Yes, Charge Cancellation Fee"
              :value="1"
            />
            <v-radio
              label="No, Do NOT Charge Cancellation Fee"
              :value="2"
            />
          </v-radio-group>
          <v-currency-field
            v-if="cancellationFee == 1"
            v-model="amount"
            type="number"
            v-bind="currency_config"
            min="0"
            class="small-text-field"
            single-line
            height="28"
            flat
          />
        </v-flex>
        <v-flex
          shrink
          pl-5
        >
          <v-checkbox
            v-if="bookingHasOtherTripToCancel"
            v-model="cancelOtherTrip"
            :label="'Cancel ' + nameForOtherTrip + ' trip'"
          />
        </v-flex>
      </v-row>
      <v-row>
        <v-flex
          v-if="booking.card_payment_type == 'prepaid'"
          shrink
        >
          <v-radio-group v-model="cancellationFee">
            <v-radio
              label="Use System Policy"
              :value="0"
            />
            <v-radio
              label="Yes, Charge Cancellation Fee"
              :value="1"
            />
            <v-radio
              label="No, Do NOT Charge Cancellation fee"
              :value="2"
            />
          </v-radio-group>
          
        </v-flex>
<!--
        <v-flex
          v-if="booking.card_payment_type != 'prepaid' && booking.payment_type == 'card'"
          shrink
        >
          <p>Cancellation Fee</p>
          <v-radio-group v-model="cancellationFee">
            <v-radio
              :label="'Use System Policy'"
              :value="0"
            />
            <v-radio
              label="Yes, Charge Cancellation Fee"
              :value="1"
            />
            <v-radio
              label="No, Do NOT Charge Cancellation Fee"
              :value="2"
            />
          </v-radio-group>
          <v-currency-field
            v-if="cancellationFee == 1"
            v-model="amount"
            type="number"
            v-bind="currency_config"
            min="0"
            class="small-text-field"
            single-line
            height="28"
            flat
          />
        </v-flex>
-->
        <v-flex
          shrink
          pl-5
        >
          <v-checkbox
            v-if="bookingHasOtherTripToCancel"
            v-model="cancelOtherTrip"
            :label="'Cancel ' + nameForOtherTrip + ' trip'"
          />
        </v-flex>
      </v-row>
    </v-flex>
    <v-card-actions>
      <v-spacer />
      <v-btn
        flat
        text
        @click="closeCancel"
      >
        Back
      </v-btn>
      <v-btn
        flat
        text
        @click="cancel"
      >
        Confirm Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: "CancelBooking",
  props: {
    booking: {
      default: null,
      type: Object
    }
  },
  data () {
    return {
      cancelDialog: false,
      cancellationFee: false,
      cancellationReason: "",
      otherCancellationReason: "",
      cancelOtherTrip: false,
      amount: null,
      cancellationFeeAmount: 0,
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true
      },
    }
  },
  computed: {
    bookingHasOtherTrip: function() {
      if (this.booking.cart != null) {
        return true;
      }

      return false;
    },
    nameForOtherTrip: function () {
      if (
          this.booking.cart.outboundBookingId ==
          this.booking.id
      ) {
        return "Return";
      } else {
        return "Outbound";
      }
    },
    bookingHasOtherTripToCancel: function () {
      if (this.booking.cart == null) {
        return false;
      }

      if (
          this.booking.cart.outboundBookingId ==
          this.booking.id
      ) {
        if (this.booking.cart.returnBookingId != null) {
          if (
              this.booking.cart.returnState != "completed" &&
              this.booking.cart.returnState != "cancelled"
          ) {
            return true;
          }
        }
      } else {
        if (
            this.booking.cart.outboundState != "completed" &&
            this.booking.cart.outboundState != "cancelled"
        ) {
          return true;
        }
      }

      return false;
    },
  },
  methods: {
    closeCancel () {
      this.$emit('closeCancelDialog')
    },
    copyBooking () {
      return window.open('/book?rebook=' + this.booking.id)
    },
    showCancel: async function() {
      this.cancelDialog = true

      try {
        var url = `${this.$store.state.apiUrl}/booking/getCancellationFee/${this.booking.id}`;

        let response = await axios.get(url, {
          params: {}
        });

        console.log(response.data);

        this.cancellationFeeAmount = response.data.cancellationFee
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
    showChangeUser: function () {
      this.$emit("change", null);
      console.log("Show change user");
    },
    expand: function () {
      this.$emit("expand", null);
    },
    close: function () {
      window.close()
      this.$emit("close", null);
    },
    bookAndReturn: function () {
      this.$emit("bookAndReturn", null);
    },
    bookAndCopy: function () {
      this.$emit("bookAndCopy", null);
    },
    book: function () {
      this.$emit("book", null);
    },
    backdateTrip: function () {
      this.$emit("backdate", null);
    },
    update: function () {
      this.$emit("update", null);
    },
    cancel: function () {

      if (this.cancellationFee != 1) {
        this.amount = null;
      }

      if (this.cancellationFee == 1 && this.amount == null) {
        alert("Please enter a fee")
        return;
      }
      
      if (!this.cancellationReason) {
        this.$snackbar.error("Please select cancellation reason")
        return;
      }
      if (!this.otherCancellationReason) {
        this.$snackbar.error("Please type cancellation reason")
        return;
      }

      this.cancelDialog = false;
      this.cancelRide(this.cancelledBooking, {
        cancellationFee: this.cancellationFee,
        cancelOtherTrip: this.cancelOtherTrip,
        amount: this.amount
      })
    },
    clear: function () {
      this.clear();
    },
    cancelRide(done, params) {
      console.log("Cancel called");

      var url = `${this.$store.state.apiUrl}/booking/cancel/${this.booking.id}?cancelOtherTripInPair=${params.cancelOtherTrip}`;

      console.log(params);

      if (params.cancellationFee == 1) {
        url += `&chargeCancellationFee=true`

        if (params.amount != null && params.amount > 0) {
          url += `&cancellationFee=${(params.amount * 100).toFixed(0)}`;
        }
      } else if (params.cancellationFee === 2) {
        url += `&chargeCancellationFee=false`
      }
      if (this.cancellationReason != "") {
        url += `&cancellationReason=${this.cancellationReason}`
      }
      if (this.otherCancellationReason != "") {
        url += `&cancellationReasonDescription=${this.otherCancellationReason}`
      }
      
      

      console.log(url);

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
          .then(function (res) {
            if (res.data.error == "no_error") {
              done();
              // alert("Booking Cancelled");
              console.log("Cancelled trip");
            } else {
              // todo better errors
              alert(res.data.error);

              if (res.data.message != null) {
                alert(res.data.message);
              }

              console.log("Failed to cancel booking");
            }
          })
          .catch(function (err) {
            console.error(err);
          });
    },
    cancelledBooking: function () {
      alert('Ride Cancelled')
      this.$emit('cancelled')
    },
  }
}
</script>

<style scoped>

</style>